import { render, staticRenderFns } from "./commodityMaintenance.vue?vue&type=template&id=38661f7e&scoped=true"
import script from "./commodityMaintenance.vue?vue&type=script&lang=js"
export * from "./commodityMaintenance.vue?vue&type=script&lang=js"
import style0 from "./commodityMaintenance.vue?vue&type=style&index=0&id=38661f7e&prod&scoped=true&lang=css"
import style1 from "./commodityMaintenance.vue?vue&type=style&index=1&id=38661f7e&prod&lang=css"
import style2 from "./commodityMaintenance.vue?vue&type=style&index=2&id=38661f7e&prod&scoped=true&lang=scss"
import style3 from "./commodityMaintenance.vue?vue&type=style&index=3&id=38661f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38661f7e",
  null
  
)

export default component.exports